import React, {Component} from 'react';
import {connect} from 'react-redux';
import Raven from 'raven-js';

import {
    Button,
    Col, Collapse,
    Container,
    Row
} from 'reactstrap';

import {handleRemoveRoommate} from '../actions/roommates';
import {handleLeaveGroup} from '../actions/roommates';

import AddInviteForm from './AddInviteForm';
import ManageGroupRow from './ManageGroupRow';
import PolyUtil from "../../../util/PolyUtil";
import Loader from "../../../components/display/Loader";
import {hideModal} from "../../../store/actions/display";
import {AsyncButton} from "../../../components/controls/buttons/AsyncButton";

class ManageGroupDialog extends Component {
    state = {
        showInvite: false,
        showConfirmLeaveCollapse: false
    };

    componentDidCatch(error, errorInfo) {
        Raven.captureException(error, {extra: errorInfo});
    }

    toggleShowInvite = () => {
        this.setState({showInvite: !this.state.showInvite});
    };

    toggleConfirmLeaveCollapse = () => {
        this.setState({showConfirmLeaveCollapse: !this.state.showConfirmLeaveCollapse});
    };

    render() {
        const {roommates, pending_invitations, email, is_coordinator, _handleRemoveRoommate, has_applied} = this.props;

        let lowerControl;
        if (is_coordinator) {
            lowerControl = !this.state.showInvite && (
                <div>
                    {
                        has_applied && (
                            <Row>
                                <Col className="center">
                                    <p className="text-danger">Inviting someone to your group will withdraw any applications you have submitted!</p>
                                </Col>
                            </Row>
                        )
                    }
                    <Row>
                        <Col className="center">
                            <Button color="success" onClick={this.toggleShowInvite} outline>Invite <i className="fa fa-plus"></i></Button>
                        </Col>
                    </Row>
                </div>
            );
        } else {
            lowerControl = (
                <Row>
                    <Col className="center">
                        {
                            !this.state.showConfirmLeaveCollapse && (<Button color="danger" onClick={this.toggleConfirmLeaveCollapse} outline>Leave Group</Button>)
                        }
                        <Collapse isOpen={this.state.showConfirmLeaveCollapse}>
                            <p><strong>Leaving your group will withdraw any applications your group has submitted!</strong><br/> Are you sure?</p>
                            <div className="center" style={{marginBottom: '1em'}}>
                                <Button block onClick={this.toggleConfirmLeaveCollapse}>Cancel</Button>
                                <AsyncButton task={() => this.props._handleLeaveGroup()} block color="danger">Leave Group</AsyncButton>
                            </div>
                        </Collapse>

                    </Col>
                </Row>
            );
        }

        return (
            <Loader spin isLoading={!PolyUtil.validArr(roommates)}>
                <Container fluid>
                    {
                        roommates.map(function (roommate, i) {
                            let isSelf = roommate.get_email === email;
                            if (!isSelf) {
                                return (
                                    <ManageGroupRow
                                        key={i}
                                        label={roommate.get_first_name + ' ' + roommate.get_last_name}
                                        subLabel={roommate.application_percent_complete === 0 ? "Not started" : roommate.application_percent_complete === 100 ? "Complete" : "In progress"}
                                        isCoordinator={is_coordinator}
                                        onRemove={() => _handleRemoveRoommate(roommate.get_first_name, roommate.get_last_name, roommate.get_email)}
                                        canRemove={is_coordinator}
                                        hasApplied={has_applied}/>
                                );
                            } else return null;
                        })
                    }
                    {
                        pending_invitations.map(function (roommate, i) {
                            return (
                                <ManageGroupRow
                                    key={i}
                                    label={roommate.get_first_name + ' ' + roommate.get_last_name}
                                    subLabel="Invited"
                                    isCoordinator={is_coordinator}
                                    disabled
                                    onRemove={() => _handleRemoveRoommate(roommate.get_first_name, roommate.get_last_name, roommate.get_email)}/>
                            );
                        })
                    }

                    {
                        this.state.showInvite && (
                            <div>
                                <Collapse isOpen={this.state.showInvite}>
                                    <Row className={this.state.showInvite && 'animated fadeIn'}>
                                        <AddInviteForm onComplete={() => this.setState({showInvite: false})}/>
                                    </Row>
                                </Collapse>
                            </div>
                        )
                    }
                    {lowerControl}


                </Container>
            </Loader>
        );
    }
}

const mapStateToProps = (state) => ({
    email: state.activeUser.email,
    roommates: state.tenant.roommate_group.roommates,
    pending_invitations: state.tenant.roommate_group.pending_invitations,
    is_coordinator: state.activeUser.email === state.tenant.roommate_group.coordinator.get_email,
    has_applied: PolyUtil.validArr(state.tenant.roommate_group.applied_listings.filter((listing) => {
        return !listing.archived;
    }))
});

const mapDispatchToProps = (dispatch) => {
    return {
        _handleRemoveRoommate(first_name, last_name, email) {
            return dispatch(handleRemoveRoommate(first_name, last_name, email));
        },
        _handleLeaveGroup() {
            return dispatch(handleLeaveGroup()).then(() => dispatch(hideModal('manage_group_modal')));
        }
    };

};

export default connect(mapStateToProps, mapDispatchToProps)(ManageGroupDialog);


// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/ManageGroupDialog.js